import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { useState, useEffect } from "react";
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import moment from "moment";
import EmployeeDropdown from "../employee/dropdown";
import ClientDropdown from "../client/dropdown";
import { MyFetch } from "../../App";
import { useLocation, useNavigate } from 'react-router-dom';
import ProgressBar from 'react-bootstrap/esm/ProgressBar';



const TasksUpdate = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [showDeleteModal, setShowDeleteModal] = useState(false); // For delete confirmation modal
    const [validated, set_Validated] = useState(false);
    const [progress, setProgress] = useState(0);

    const [form_Data, set_Form_Data] = useState({
        task_name: "",
        client_id: 0,
        emp_id: 0,
        date_due: "",
        task_desc: "",
        progress: 0

    });

    useEffect(() => {
        MyFetch(`https://easytasks.in/tasks/list/${location.state.taskid}`, {}, "GET")
            .then((res) => res.json())
            .then((data) => {
                set_Form_Data(data);
                setProgress(data.progress); // Set initial progress
            });

    }, [])

    const deleteFn = () => {
        MyFetch(`https://easytasks.in/tasks/delete`, form_Data, "DELETE")
            .then((res) => {
                if (res.status === 200) {
                    alert("task deleted successfully!")
                    navigate('/tasks/list');
                } else {
                    alert("Failed to delete task.");
                }
            })
            .catch((error) => {
                console.error("Error deleting task:", error);
                alert("Error deleting task.");
            });
    };

    const submitFn = (event) => {
        event.preventDefault(); // Prevent the default form submission behavior
        const form = event.currentTarget; // Get the form element

        // Perform validation
        if (form.checkValidity() === false) {
            event.stopPropagation(); // Stop the form from submitting if validation fails
            set_Validated(true); // Trigger validation feedback styling
        } else {
            set_Validated(true);

            MyFetch(`https://easytasks.in/tasks/update`, form_Data, "PUT")
                .then((res) => res.json())
                .then((data) => {
                    alert("Task updated successfully!"); // Notify the user
                    navigate('/tasks/list');

                })
                .catch((error) => {
                    console.error("Error updating task:", error);
                    alert("Failed to update task."); // Notify the user of any errors
                });
        }
    };

    const chngFn = (event) => {
        const { name, value } = event.target;
        set_Form_Data({
            ...form_Data,
            [name]: value,
        });
        if (name === "progress") {
            setProgress(value); // Update progress state when progress changes
        }
    };

    const chngDt = (value) => {
        set_Form_Data({
            ...form_Data,
            "date_due": moment(value).format("MM/DD/YYYY"),
        });
        console.log(form_Data)
        console.log(moment(value).format("MM/DD/YYYY"));
    };

    const getProgressBarVariant = (progress) => {
        if (progress < 20) return "danger";
        if (progress < 100) return "warning";
        return "success";
    };

    return (

        <Container className='mt-5'>
            <Row className="justify-content-md-center">
                <Col xs lg="5" >
                    <h2 className='my-5'><b>EDIT TASK</b></h2>
                    {/* {alert(location.state.taskid)} */}
                </Col>
            </Row>
            <Row className="justify-content-md-center">
                <Col xs lg="5">
                    <Form noValidate validated={validated} onSubmit={submitFn}>

                        <Form.Group className="mb-3" controlId="tasksTask_name">
                            <Form.Label>Task Name</Form.Label>
                            <Form.Control
                                type="text"
                                name="task_name"
                                value={form_Data.task_name}
                                readOnly  
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="tasksTask_desc">
                            <Form.Label>Task Description</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                name="task_desc"
                                value={form_Data.task_desc}
                                onChange={chngFn}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="tasksDate_due">
                            <Form.Label>Date Due</Form.Label>
                            <div>
                                <DatePicker
                                    name="date_due"
                                    value={form_Data.date_due} 
                                    readOnly
                                    />
                            </div>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="tasksEmp_id">
                            <Form.Label>Employee Assigned</Form.Label>
                            <EmployeeDropdown
                                name="emp_id"
                                value={form_Data.emp_id}
                                readOnly
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="tasksClient_id">
                            <Form.Label>Client</Form.Label>
                            <ClientDropdown
                                name="client_id"
                                value={form_Data.client_id}
                                readOnly
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="tasksProgress">
                            <Form.Label>Task Progress</Form.Label>
                            <Form.Control
                                type="number"
                                name="progress"
                                value={form_Data.progress}
                                onChange={chngFn}
                                min="0"
                                max="100"
                                step="1"
                                required
                                isInvalid={
                                    validated &&
                                    (isNaN(form_Data.progress) || form_Data.progress < 0 || form_Data.progress > 100)
                                }
                            />
                            <Form.Control.Feedback type="invalid">
                                Please enter a valid progress value between 0 and 100.
                            </Form.Control.Feedback>
                            <Form.Text className="text-muted">
                                {form_Data.progress}%
                            </Form.Text>

                        </Form.Group>
                        <ProgressBar
                            now={progress}
                            label={`${progress}%`}
                            variant={getProgressBarVariant(progress)}
                            className="mb-3"
                        />

                        <Button variant="primary" type="submit"> Update</Button>{' '}
                        <Button variant="danger" onClick={() => setShowDeleteModal(true)}>Delete</Button>
                    </Form>
                </Col>
            </Row>
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete this task?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                        No
                    </Button>
                    <Button variant="danger" onClick={() => {
                        deleteFn();
                        setShowDeleteModal(false);
                    }}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
}

export default TasksUpdate;


